module.exports = "/_next/static/images/img__tips_cube_top-right_desktop-12ee086e738903be57caab7f596789b1.png";